module.exports = __webpack_public_path__ + "./docs/img/php.9479a0c2c1eb83a10fe36649633559c7.svg";